/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskV2 } from './taskV2';
import { BackupOperationEnum } from './backupOperationEnum';


export interface TaskBackUpResponse { 
    action?: BackupOperationEnum;
    /**
     * Number of Task records
     */
    count?: number;
    /**
     * List of purged tasks
     */
    records?: Array<TaskV2>;
}
export namespace TaskBackUpResponse {
}


